import React, { useState } from 'react';
import { UserIcon, ChevronDownIcon, LogOutIcon, MenuIcon, XIcon, BellIcon } from 'lucide-react';
interface HeaderProps {
  isAuthenticated: boolean;
  onLogout: () => void;
}
export function Header({
  isAuthenticated,
  onLogout
}: HeaderProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const notifications = [{
    id: 1,
    message: 'Your password will expire in 7 days',
    time: '2 hours ago',
    isRead: false
  }, {
    id: 2,
    message: 'New security update available',
    time: 'Yesterday',
    isRead: true
  }, {
    id: 3,
    message: 'System maintenance scheduled for Sunday',
    time: '3 days ago',
    isRead: true
  }];
  return <header className="bg-white shadow-md border-b border-gray-200 sticky top-0 z-10" data-id="element-151">
      <div className="container mx-auto px-4 py-3" data-id="element-152">
        <div className="flex items-center justify-between" data-id="element-153">
          <div className="flex items-center" data-id="element-154">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wcGJehFU8moW1Bqmivv7jn/ethswitch_logo-1.png" alt="EthSwitch Logo" className="h-10" data-id="element-155" />
            <div className="ml-3" data-id="element-156">
              <span className="text-xl font-bold text-[#1A1F36] whitespace-nowrap block" data-id="element-157">
                EthBridge
              </span>
              <span className="text-sm text-[#F58220] whitespace-nowrap block -mt-1 font-medium" data-id="element-158">
                Bank Portal
              </span>
            </div>
          </div>
          {isAuthenticated ? <div className="flex items-center space-x-4" data-id="element-159">
              <div className="relative" data-id="element-160">
                <button onClick={() => setShowNotifications(!showNotifications)} className="p-2 rounded-full hover:bg-gray-100 relative" data-id="element-161">
                  <BellIcon size={20} className="text-gray-600" data-id="element-162" />
                  <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full" data-id="element-163"></span>
                </button>
                {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200" data-id="element-164">
                    <div className="px-4 py-2 border-b border-gray-100" data-id="element-165">
                      <h3 className="text-sm font-semibold" data-id="element-166">Notifications</h3>
                    </div>
                    <div className="max-h-64 overflow-y-auto" data-id="element-167">
                      {notifications.map(notification => <div key={notification.id} className={`px-4 py-3 border-b border-gray-100 ${!notification.isRead ? 'bg-blue-50' : ''}`} data-id="element-168">
                          <p className="text-sm text-gray-800" data-id="element-169">
                            {notification.message}
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-170">
                            {notification.time}
                          </p>
                        </div>)}
                    </div>
                    <div className="px-4 py-2 text-center" data-id="element-171">
                      <button className="text-xs text-[#F58220] hover:text-[#e07619] font-medium" data-id="element-172">
                        View all notifications
                      </button>
                    </div>
                  </div>}
              </div>
              <div className="relative" data-id="element-173">
                <button onClick={() => setShowUserMenu(!showUserMenu)} className="flex items-center space-x-2 text-gray-700 hover:text-[#F58220] focus:outline-none" data-id="element-174">
                  <div className="w-9 h-9 bg-[#F58220] bg-opacity-10 rounded-full flex items-center justify-center" data-id="element-175">
                    <UserIcon size={18} className="text-[#F58220]" data-id="element-176" />
                  </div>
                  <div className="hidden md:block text-left" data-id="element-177">
                    <p className="text-sm font-medium text-gray-800" data-id="element-178">
                      Admin User
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-179">Administrator</p>
                  </div>
                  <ChevronDownIcon size={16} data-id="element-180" />
                </button>
                {showUserMenu && <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200" data-id="element-181">
                    <a href="#profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-182">
                      Profile
                    </a>
                    <a href="#settings" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-183">
                      Settings
                    </a>
                    <div className="border-t border-gray-100 my-1" data-id="element-184"></div>
                    <button onClick={onLogout} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-185">
                      <LogOutIcon size={16} className="mr-2" data-id="element-186" /> Logout
                    </button>
                  </div>}
              </div>
            </div> : <a href="#contact" className="text-[#F58220] hover:text-[#e07619] font-medium" data-id="element-187">
              Contact Us
            </a>}
        </div>
      </div>
    </header>;
}